export const getCurso = curso => {
  if (curso) return `${curso}º`
  if (curso === 0) return ''
  return '[Curso desconocido]'
}

export const getNivel = ({ curso, nivel }) => {
  const infoCurso = getCurso(curso)
  const infoNivel = nivel ? `${nivel} ` : '[Nivel desconocido] '
  return `${infoCurso} ${infoNivel}`
}

export const getPerfilAcademico = ({ curso, nivel, centroEstudios }) => {
  const infoCurso = getCurso(curso)
  const infoNivel = nivel ? `${nivel} ` : '[Nivel desconocido] '
  const infoCentro = centroEstudios
    ? `${centroEstudios}`
    : '[Centro de estudios desconocido]'
  return `${infoCurso} ${infoNivel} - ${infoCentro}`
}

export const validarAlumno = ({
  nombre,
  apellidos,
  fechaNacimiento,
  facturacionNombre,
  facturacionIdentificacion,
  lead
}) => {
  const errors = []
  if (!nombre) errors.push('Es necesario indicar el nombre del alumno')
  if (!apellidos) errors.push('Es necesario indicar el apellido del alumno')
  if (!fechaNacimiento)
    errors.push('Es necesario indicar la fecha de nacimiento del alumno')
  if (!facturacionNombre)
    errors.push('Es necesario indicar el titular para la facturación')
  if (!facturacionIdentificacion)
    errors.push('Es necesario indicar la identificación para la facturación')
  if (!lead) errors.push('Es necesario indicar el lead asociado al alumno')
  return {
    status: errors.length === 0 ? 'ok' : 'error',
    errors
  }
}
